
import { Placement } from '@post-office/placements-frontend/fastshift-portal';
export default Placement;
